import {
  GET_SELLERS_REQUEST,
  GET_SELLERS_SUCCESS,
  GET_SELLERS_FAILURE,
  GET_ONE_SELLER_REQUEST,
  GET_ONE_SELLER_SUCCESS,
  GET_ONE_SELLER_FAILURE,
  UPDATE_SELLER_REQUEST,
  UPDATE_SELLER_SUCCESS,
  UPDATE_SELLER_FAILURE
} from "src/actions/sellerActions";
import produce from "immer";

const initialState = {
  sellers: [],
  seller: {},
  total: 0,
  loadingGetSellers: false,
  loadingGetOneSeller: false,
  loadingUpdateSeller: false
  // loadingUpdatePermissionOfSellers: false,
  // loadingUpdateActiveSellers: false,
};

const sellerReducer = (state = initialState, action) => {
  switch (action.type) {
    // Case Get Sellers
    case GET_SELLERS_REQUEST: {
      return produce(state, (draft) => {
        draft.sellers = [];
        draft.loadingGetSellers = true;
      });
    }

    case GET_SELLERS_SUCCESS: {
      const {response, total} = action.payload;
      return produce(state, (draft) => {
        draft.sellers = response;
        draft.loadingGetSellers = false;
        draft.total = total;
      });
    }

    case GET_SELLERS_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingGetSellers = false;
      });
    }

    // Case Get One Seller
    case GET_ONE_SELLER_REQUEST: {
      return produce(state, (draft) => {
        draft.seller = {};
        draft.loadingGetOneSeller = true;
      });
    }

    case GET_ONE_SELLER_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.seller = response;
        draft.loadingGetOneSeller = false;
      });
    }

    case GET_ONE_SELLER_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingGetOneSeller = false;
      });
    }

    // Case Update Seller
    case UPDATE_SELLER_REQUEST: {
      return produce(state, (draft) => {
        draft.loadingUpdateSeller = true;
      });
    }

    case UPDATE_SELLER_SUCCESS: {
      return produce(state, (draft) => {
        draft.loadingUpdateSeller = false;
      });
    }

    case UPDATE_SELLER_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingUpdateSeller = false;
      });
    }

    default: {
      return state;
    }
  }
};

export default sellerReducer;
